import axios from "axios";
import { baseUrl } from "../boot";

// Add Area
export const NotificationSaveTokenApi = async (formData) => {
  console.log("save  token formdata", formData);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/notification/app/v1/save-token`, formData, {
      headers: {
        "auth-token": token,
      },
    });

    console.log("nt token ", response);
    return response;
  } catch (error) {
    console.log({ error });
    throw error;
  }
};

export const NotificationSendApi = async (formData) => {
  // console.log("sned noti formdata", formData);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/notification/app/v1/send-notification`, formData, {
      headers: {
        "auth-token": token,
      },
    });

    console.log("token", response);
    return response;
  } catch (error) {
    console.log({ error });
    throw error;
  }
};

// get notifications

export const getNotificationApi = async (formData) => {
  // console.log("token formdata", formData);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/notification/app/v1/get-notification-list/${formData}`, {
      headers: {
        "auth-token": token,
      },
    });

    console.log("resp", response);
    return response;
  } catch (error) {
    console.log({ error });
    throw error;
  }
};

export const updateNoticationApi = async (formData) => {
  // console.log(" formdata", formData);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/notification/app/v1/update-notification/${formData}`, {
      headers: {
        "auth-token": token,
      },
    });

    console.log("resp", response);
    return response;
  } catch (error) {
    console.log({ error });
    throw error;
  }
};

export const markAllReadNoticationApi = async (formData) => {
  // console.log(" formdata", formData);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/notification/app/v1/bulk-update-notification/${formData}`, {
      headers: {
        "auth-token": token,
      },
    });

    console.log("resp", response);
    return response;
  } catch (error) {
    console.log({ error });
    throw error;
  }
};

// clear all notifications
export const clearAllNotificationApi = async (formData) => {
  // console.log(" formdata", formData);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/notification/app/v1/clear-notification/${formData}`, {
      headers: {
        "auth-token": token,
      },
    });

    console.log("resp", response);
    return response;
  } catch (error) {
    console.log({ error });
    throw error;
  }
};
